import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgChartsModule } from "ng2-charts";
import { routes } from "src/app/app.router";
import { DsoGuardComponent } from "./dso-guard.component";
import { DsoGuardAuthoringToolsComponent } from "./authoring-tools/dso-guard-authoring-tools.component";
import { DashboardComponent } from "./authoring-tools/dashboard/dashboard.component";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  declarations: [
    DsoGuardAuthoringToolsComponent,
    DashboardComponent
  ],
  imports: [
    routes,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    NgbModule,
    NgChartsModule ,
    SharedModule
  ]
})
export class DsoGuardModule { }